import FlexBox from '../../layouts/Flexbox'
import { Stack, Typography } from '@mui/material'
import { APP_COLORS } from '../../../enums/colors'
import somethingWentWrong from '../../../assets/images/something-went-wrong.png'

export function SomethingWentWrong({ title = "Something went wrong!", message = "Please try again later" }) {
    return (
        <FlexBox alignItems={"center"} gap={2}>
            <img src={somethingWentWrong} alt="Something went wrong" />
            <Stack gap={1}>
                <Typography variant="heading6-helveticaNeue" color={APP_COLORS.errorDark}>{title}</Typography>
                <Typography variant="body-ibmPlexMono" color={APP_COLORS.textSecondary}>{message}</Typography>
            </Stack>
        </FlexBox>
    )
}
